var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNordic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.6,30.3H45.7v11.9h23c-0.5,0.1,1.1-0.1,2.2-0.4c0.7-0.2,1.4-0.7,2-1.3c0.6-0.6,1-1.3,1.3-2s0.4-1.5,0.4-2.2 s-0.1-1.5-0.4-2.2s-0.7-1.4-1.3-2L49.6,8.7c-1.3-1.3-3.5-1.3-4.8,0c-1.3,1.3-1.3,3.5,0,4.8L61.6,30.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.4,
    cy: 31.2,
    rx: 6,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3,69.6c0.9,0,1.7-0.3,2.4-1L42.3,40v-9.6L8.9,63.8c-0.7,0.7-1,1.5-1,2.4c0,0.9,0.3,1.7,1,2.4 C9.6,69.2,10.5,69.6,11.3,69.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.4,84.5l-30.1,30.1c-1.3,1.3-1.3,3.5,0,4.8c1.3,1.3,3.5,1.3,4.8,0l25.3-25.3l14.4,14.4v19.1c0,1.9,1.5,3.4,3.4,3.4 s3.4-1.5,3.4-3.4v-20.5c0-0.9-0.4-1.8-1-2.4L91.4,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1,59.5c-2.3-2.3-6.1-2.3-8.4,0c-2.3,2.3-2.3,6.1,0,8.4s6.1,2.3,8.4,0C129.4,65.6,129.4,61.8,127.1,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.1,71.1l-6.6-6.6c-0.7-0.7-1.5-1-2.4-1H95.4c-0.9,0-1.7,0.3-2.4,1l-9.6,9.6c-0.3,0.3-0.5,0.7-0.7,1.1H51.4v2.7h31.2 c0.2,0.4,0.4,0.7,0.7,1.1c0.7,0.7,1.5,1,2.4,1s1.7-0.3,2.4-1l8.6-8.6h8.8L93.8,82.1L104.6,93L118,79.6 C120.4,77.2,120.4,73.5,118.1,71.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129,136.4H83.8v-2.7H129c2.5,0,4.6-2.1,4.6-4.6h2.7C136.3,133.1,133,136.4,129,136.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8,136.4c-1.9,0-3.8-0.7-5.2-2.1L33.1,98.8l1.9-1.9l35.5,35.5c1.8,1.8,4.7,1.8,6.5,0l1.9,1.9 C77.5,135.7,75.7,136.4,73.8,136.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,51.9l-2.7,0.2c0.1,0.9-0.1,1.8-0.6,2.7c-0.6,1.1-1.6,1.8-2.8,2.1L0,76.2V79l72.6-19.5c1.9-0.5,3.5-1.7,4.4-3.4 C77.8,54.8,78.1,53.4,78,51.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordic);
export default __webpack_public_path__ + "static/media/nordic.db8cfb47bd300744a8722ff5a25b05c4.svg";
export { ForwardRef as ReactComponent };